<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">
    <div v-show="Isblur" class="splash"></div>

    <sidebar></sidebar>
    <!-- Jobs -->
    <div class="card-panel-main col-lg-9 mb-5" style="transform: translateX(-19vw)">
      <div class="row">
        <InformationProcessId :id_route="id_route"/>
      </div>
      <div class="row">
        <Documents :id_route="id_route"/>

      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="card card-body card-procces-id-main border-0">
            <h2>مشخصات فرآیند طبق مدل مرجع SIPOC</h2>
            <div class="d-flex flex-column">
              <InformationInsert :id_route="id_route" />
              <Tasks :id_route="id_route"/>
              <InformationExit :id_route="id_route"/>
              <References :id_route="id_route" />


            </div>
          </div>
        </div>
      </div>
      <ProcessMonitoring :id_route="id_route" />
      <Matrix :id_route="id_route" />
      <Knowledge :id_route="id_route" />
      <Risk :id_route="id_route" />

      <div class="form-buttons row mt-4 mb-5 d-flex justify-content-center">
      </div>
    </div>
  </div>
<!-- **************************************************************************************************************************** -->

</template>

<script>
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import Splash from "@/components/Splash/Splash.vue";
import InformationProcessId from "@/components/process_id/mother/InformationProcessId.vue";
import router from "../../../router";
import Documents from "@/components/process_id/mother/Documents";
import InformationInsert from "@/components/process_id/mother/InformationInsert.vue";
import InformationExit from "@/components/process_id/mother/InformationExit.vue";
import Tasks from "@/components/process_id/mother/Tasks.vue";
import References from "@/components/process_id/mother/References.vue";
import ProcessMonitoring from "@/components/process_id/mother/ProcessMonitoring.vue";
import Matrix from "@/components/process_id/mother/matrix.vue";
import Knowledge from "@/components/process_id/mother/Knowledge.vue";
import Risk from "@/components/process_id/mother/Risk.vue";
export default {
  name: "process_id",
  components: {InformationExit, InformationInsert, Documents, Splash, Sidebar,InformationProcessId, Tasks,References, ProcessMonitoring,Matrix,Risk,Knowledge},
  data(){
    return{
      id_route: this.$route['params']['id'],

    }
  },
  methods:{
    checkIsMother(){
      if (!this.is_mother){
        router.push('/')
      }

    }
  },
  mounted() {
    this.checkIsMother()
  }

}
</script>

<style scoped>
.row{
  padding: .5vw;
}

</style>